import React from 'react';
import { Camera, Video, Users, Heart } from 'lucide-react';
import './Services.css';

const iconMap = {
  Camera: Camera,
  Video: Video,
  Users: Users,
  Heart: Heart
};

const Services = ({ data }) => {
  return (
    <section className="services" id="services">
      <div className="services-container">
        <div className="services-header">
          <p className="section-subtitle">{data.subtitle}</p>
          <h2 className="section-title">{data.title}</h2>
        </div>

        <div className="services-grid">
          {data.items.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <div key={service.id} className="service-card">
                <div className="service-icon-wrapper">
                  <div className="service-icon">
                    <Icon size={32} />
                  </div>
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <div className="service-decoration"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
